import { type ReactNode } from 'react';
import { useAppealForm } from '../hooks/use-appeal-form';
import {
  AppealChips,
  AppealFooter,
  AppealHelp,
  AppealTextarea,
  type AppealFormHook,
} from './creator-appeal-confirm-parts';

type Props = {
  onConfirm: (description: string) => void;
  onCancel: () => void;
  isPending: boolean;
  serverError?: string | undefined;
};

function FieldBlock(p: { f: AppealFormHook }): ReactNode {
  const { f } = p;
  return (
    <>
      <AppealChips current={f.description} onPick={f.applyTemplate} />
      <AppealTextarea
        value={f.description}
        bad={!!f.error}
        onChange={f.setText}
      />
      {f.error && <p className="text-xs text-error">{f.error}</p>}
    </>
  );
}

function AppealBody(p: {
  f: AppealFormHook;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}): ReactNode {
  return (
    <>
      <AppealHelp />
      <FieldBlock f={p.f} />
      <AppealFooter
        length={p.f.trimmed.length}
        bad={p.f.touched && p.f.tooShort}
        disabled={p.f.tooShort}
        isPending={p.isPending}
        onCancel={p.onCancel}
        onConfirm={p.onConfirm}
      />
    </>
  );
}

export function CreatorAppealConfirm(props: Props): ReactNode {
  const f = useAppealForm(props.serverError);
  return (
    <div className="flex flex-col gap-sm border-t border-white/[0.06] pt-base">
      <AppealBody
        f={f}
        isPending={props.isPending}
        onCancel={props.onCancel}
        onConfirm={() => props.onConfirm(f.trimmed)}
      />
    </div>
  );
}
